import { gql } from "@apollo/client";

export const GET_MAIN_INTERESTS = gql`
  query getInterests($where: interests_bool_exp!) {
    interests(where: $where) {
      name_en
      name_es
      name_fr
      name_ukr
      color
      active
      id
    }
  }
`;

export const GET_SUB_INTERESTS = gql`
  query getSubInterests($where: interests_bool_exp!) {
    interests(where: $where) {
      name_en
      name_es
      name_fr
      name_ukr
      color
      active
      id
    }
  }
`;

export const GET_SUB_SUB_INTERESTS = gql`
  query getSubSubInterests($where: interests_bool_exp!) {
    interests(where: $where) {
      name_en
      name_es
      name_fr
      name_ukr
      color
      active
      id
    }
  }
`;


export const GET_SINGLE_INTEREST = gql`
  query getSingleInterests($where: interests_bool_exp) {
    interests(where: $where) {
      id
      depth
      color
      parent_id
      name_en
      name_es
      name_fr
      name_ukr
      active
    }
  }
`;

export const UPDATE_INTEREST = gql`
  mutation updateInterest($id: String, $data: interests_set_input!) {
    update_interests(where: { id: { _eq: $id } }, _set: $data) {
      affected_rows
    }
  }
`;


export const GET_INTEREST_REQUESTS = gql`
  query getInterestsRequests {
  interest_requests(where: {is_deleted: {_eq: false}}) {
    id
    interest
    accepted
    message
    user_email
    created_at
  }
}
`;

export const DELETE_INTEREST_REQUEST = gql`
  mutation deleteInterestRequest($id: uuid!) {
    update_interest_requests(
      where: { id: { _eq: $id } }
      _set: { is_deleted: true }
    ) {
      affected_rows
      returning {
          is_deleted
          id
      }
    }
  }
`;